import { BigNumber, ethers } from 'ethers';

/**
 * erc20 전송을 위한 HashedTimelock Contract의 contractId 생성기
 * @param from erc20 토큰을 보내려고 하는 EOA (트랜잭션을 서명하는 자)
 * @param receiver erc20 토큰을 받는 EOA
 * @param erc20Address erc20 토큰의 contract address
 * @param amount 보내려고 하는 토큰의 양
 * @param hashlock 해시락
 * @param timelock 타임락
 * @returns hex string
 */
export function generateContractIdOfErc20Htlc(
  from: string,
  receiver: string,
  erc20Address: string,
  amount: BigNumber,
  hashlock: string,
  timelock: number,
): string {
  const contractId = ethers.utils.soliditySha256(
    [`address`, `address`, `address`, `uint`, `bytes`, `uint`],
    [from, receiver, erc20Address, amount, hashlock, timelock],
  );
  return contractId;
}

/**
 * coin 전송을 위한 HashedTimelock Contract의 contractId 생성기
 * @param from coin을 보내려고 하는 EOA (트랜잭션을 서명하는 자)
 * @param receiver coin을 받는 EOA
 * @param amount 보내려고 하는 코인의 양
 * @param hashlock 해시락
 * @param timelock 타임락
 * @returns hex string
 */
export function generateContractIdOfCoinHtlc(
  from: string,
  receiver: string,
  amount: BigNumber,
  hashlock: string,
  timelock: number,
): string {
  const contractId = ethers.utils.soliditySha256(
    [`address`, `address`, `uint`, `bytes`, `uint`],
    [from, receiver, amount, hashlock, timelock],
  );
  return contractId;
}

/**
 * HashedTimelock을 위한 preimage 생성기
 * @returns array of 8-bit unsigned integers
 */
export function generatePreimage(): Uint8Array {
  const preimage = ethers.utils.randomBytes(32);
  return preimage;
}

/**
 * HashedTimelock을 위한 timelock 생성기
 * @returns unix time
 */
export function generateTimelock(): number {
  const currentTime = Math.floor(Date.now() / 1000); // seconds
  const timelock =
    process.env.REACT_APP_ENV === `development`
      ? // || process.env.REACT_APP_ENV === `stage`
        // dev환경에서의 timeock이 수정될 우려가 있어 우선 주석처리
        currentTime + 3000 // 50분
      : currentTime + 86400 * 2 + 60 * 60 * 10; // 2일 10시간
  return timelock;
}
